import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "tw-truncate" };
import { cn } from '@/lib/utils';
import { TabsTrigger, useForwardProps } from 'radix-vue';
import { computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'TabsTrigger',
    props: {
        value: {},
        disabled: { type: Boolean },
        asChild: { type: Boolean },
        as: {},
        class: {}
    },
    setup(__props) {
        const props = __props;
        const delegatedProps = computed(() => {
            const { class: _, ...delegated } = props;
            return delegated;
        });
        const forwardedProps = useForwardProps(delegatedProps);
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(TabsTrigger), _mergeProps(_unref(forwardedProps), {
                class: _unref(cn)('tw-inline-flex tw-items-center tw-justify-center tw-whitespace-nowrap tw-rounded-sm tw-px-3 tw-py-1.5 tw-text-sm tw-font-medium tw-ring-offset-background tw-transition-all focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ring focus-visible:tw-ring-offset-2 disabled:tw-pointer-events-none disabled:tw-opacity-50 data-[state=active]:tw-bg-background data-[state=active]:tw-text-foreground data-[state=active]:tw-shadow-sm', props.class)
            }), {
                default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_1, [
                        _renderSlot(_ctx.$slots, "default")
                    ])
                ]),
                _: 3
            }, 16, ["class"]));
        };
    }
});
